import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';
export const FitnessStationIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    width: props.width || '15',
    height: props.height || '19',
    fill: props.fill || '#43494F',
  };
  return (
    <svg viewBox="0 0 15 19" {...svgProps} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.875 6C4.62708 6 4.41942 5.91629 4.252 5.74887C4.084 5.58087 4 5.37292 4 5.125V4.25C4 4.00208 4.084 3.79413 4.252 3.62613C4.41942 3.45871 4.62708 3.375 4.875 3.375C5.12292 3.375 5.33088 3.45871 5.49888 3.62613C5.66629 3.79413 5.75 4.00208 5.75 4.25V5.125C5.75 5.37292 5.66629 5.58087 5.49888 5.74887C5.33088 5.91629 5.12292 6 4.875 6ZM4.875 13.875C4.62708 13.875 4.41942 13.791 4.252 13.623C4.084 13.4556 4 13.2479 4 13V10.375C4 10.1271 4.084 9.91912 4.252 9.75112C4.41942 9.58371 4.62708 9.5 4.875 9.5C5.12292 9.5 5.33088 9.58371 5.49888 9.75112C5.66629 9.91912 5.75 10.1271 5.75 10.375V13C5.75 13.2479 5.66629 13.4556 5.49888 13.623C5.33088 13.791 5.12292 13.875 4.875 13.875ZM2.25 18.25C1.76875 18.25 1.35692 18.0788 1.0145 17.7364C0.6715 17.3934 0.5 16.9813 0.5 16.5V2.5C0.5 2.01875 0.6715 1.60662 1.0145 1.26362C1.35692 0.921208 1.76875 0.75 2.25 0.75H12.75C13.2312 0.75 13.6434 0.921208 13.9864 1.26362C14.3288 1.60662 14.5 2.01875 14.5 2.5V16.5C14.5 16.9813 14.3288 17.3934 13.9864 17.7364C13.6434 18.0788 13.2312 18.25 12.75 18.25H2.25ZM2.25 16.5H12.75V8.625H2.25V16.5ZM2.25 6.875H12.75V2.5H2.25V6.875Z"
        fill={svgProps.fill}
      />
    </svg>
  );
};

FitnessStationIcon.iconType = ICON_TYPES.FITNESS_STATION_ICON;
